import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'header',
  'title',
  'toggleAllButton',
  'toggleAllButtonText',
  'toggleAllButtonIcon',
  'content',
  'accordions',
  'accordion',
  'mediaContainer',
  'mediaWrapper',
  'media'
]);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "header" | "title" | "toggleAllButton" | "toggleAllButtonText" | "toggleAllButtonIcon" | "content" | "accordions" | "accordion" | "mediaContainer" | "mediaWrapper" | "media")[]
 * }>} AccordionPanelStyles
 */
export const accordionPanelStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.AccordionPanel} args.component - AccordionPanel component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {AccordionPanelStyles} - Component styles
   */
  baseStyle({component, isComplete, isFetching}) {
    const hasMedia = Boolean(component?.media);

    return {
      root: {
        width: 'full',
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: {base: 6, lg: 8}, // 24px mobile, 32px desktop
      },
      title: {
        fontFamily: 'heading',
        fontSize: {base: '1.75rem', lg: '2.5rem'}, // 28px mobile, 40px desktop
        fontWeight: 'normal',
        lineHeight: '1.2',
        letterSpacing: '-0.01em', // -1%
        color: 'brandColors.greyscale',
      },
      toggleAllButton: {
        display: 'flex',
        alignItems: 'center',
        gap: 2, // 8px
        px: 0,
        py: 2,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        _hover: {
          background: 'transparent',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
      toggleAllButtonText: {
        fontFamily: 'body',
        fontSize: 'md', // 16px
        color: 'black',
      },
      toggleAllButtonIcon: {
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'black',
      },
      content: {
        width: 'full',
        gap: {base: 6, lg: 0}, // 24px mobile, 0
        alignItems: {base: 'stretch', lg: 'flex-start'},
      },
      accordions: {
        flex: hasMedia ? {base: 'none', lg: '1 1 0'} : '1 1 0',
        width: hasMedia ? {base: 'full', lg: 'auto'} : 'full',
        minWidth: 0, // Prevent flex item from overflowing
      },
      accordion: {
        width: 'full',
      },
      mediaContainer: {
        flexShrink: 0,
        width: {base: 'full', lg: '50%'},
        display: {base: 'block', lg: 'block'},
        paddingLeft: {lg: '80px'},
      },
      mediaWrapper: {
        width: '100%',
        sx: {
          '& img': {
            width: '100%',
            maxWidth: '100%',
          },
        },
      },
      media: {
        width: 'full',
        height: 'auto',
      },
    };
  },
});
